import React from "react";
import { Blog } from "../features";
import { Grid } from "@material-ui/core";

function BlogPage() {
  return (
    <>

        <Blog.Container />

    </>
  );
}

export default BlogPage;
